var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { AccordionSet, Accordion, Button } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekSelection } from "./inputs";
import { fetchOnixCodetables, ONIX_CODETABLE_CACHE_MS, } from "../api/onixService";
import { fetchAllPages } from "../utils/fetchAllPages";
export var OnixCodetablesFilters = function (_a) {
    var _b;
    var temporaryNumberFilter = _a.temporaryNumberFilter, temporaryNameFilter = _a.temporaryNameFilter, onNumberFilterChange = _a.onNumberFilterChange, onNameFilterChange = _a.onNameFilterChange, onApplyFilters = _a.onApplyFilters;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var data = useQuery(["onix-codetables-options"], function () { return __awaiter(void 0, void 0, void 0, function () {
        var items;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchAllPages(function (offset, limit) {
                        return fetchOnixCodetables(ky, { offset: offset, limit: limit, includeItems: false });
                    })];
                case 1:
                    items = _a.sent();
                    return [2 /*return*/, { items: items, totalRecords: items.length }];
            }
        });
    }); }, {
        staleTime: ONIX_CODETABLE_CACHE_MS,
        cacheTime: ONIX_CODETABLE_CACHE_MS,
    }).data;
    var all = (_b = data === null || data === void 0 ? void 0 : data.items) !== null && _b !== void 0 ? _b : [];
    var numberOptions = useMemo(function () {
        var set = new Set();
        all.forEach(function (i) {
            if (i.number !== undefined && i.number !== null)
                set.add(i.number);
        });
        return Array.from(set)
            .sort(function (a, b) { return a - b; })
            .map(function (n) { return ({ value: String(n), label: String(n) }); });
    }, [all]);
    var nameOptions = useMemo(function () {
        var set = new Set();
        all.forEach(function (i) {
            if (i.name)
                set.add(i.name);
        });
        return Array.from(set)
            .sort()
            .map(function (n) { return ({ value: n, label: n }); });
    }, [all]);
    var handleNumberChange = function (val) {
        onNumberFilterChange(val);
        var match = all.find(function (i) { return String(i.number) === val; });
        if (match === null || match === void 0 ? void 0 : match.name)
            onNameFilterChange(match.name);
        else if (!val)
            onNameFilterChange("");
    };
    var handleNameChange = function (val) {
        onNameFilterChange(val);
        var match = all.find(function (i) { return i.name === val; });
        if ((match === null || match === void 0 ? void 0 : match.number) !== undefined && (match === null || match === void 0 ? void 0 : match.number) !== null) {
            onNumberFilterChange(String(match.number));
        }
        else if (!val)
            onNumberFilterChange("");
    };
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.onixCodetablesList.accordion.label.list.filterByNumber",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.onixCodetablesList.accordion.label.list.filterByNumber", showLabel: false, name: "numberFilter", value: temporaryNumberFilter, onChange: handleNumberChange, dataOptions: __spreadArray([
                        {
                            value: "",
                            label: formatMessage({ id: "ui-br-agency.filter.all" }),
                        }
                    ], numberOptions, true) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.onixCodetablesList.accordion.label.list.filterByName",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.onixCodetablesList.accordion.label.list.filterByName", showLabel: false, name: "nameFilter", value: temporaryNameFilter, onChange: handleNameChange, dataOptions: __spreadArray([
                        {
                            value: "",
                            label: formatMessage({ id: "ui-br-agency.filter.all" }),
                        }
                    ], nameOptions, true) }))),
        React.createElement(Button, { type: "submit", marginBottom0: true }, formatMessage({ id: "ui-br-agency.button.apply" }))));
};
